import { defineStore } from 'pinia'

export const authStore = defineStore({
  'id': 'auth',
  state: () => ({
    token: null,
    userData: null,
    customerData: null,
    expireToken: null,
  }),
  actions: {
    setToken(tokenValue) {
      this.token = tokenValue
    },
    setExpireToken(expire) {
      this.expireToken = expire
    },
    setUserData(userDataValue) {
      this.userData = userDataValue
    },
    setCustomerData(customerDataValue) {
      this.customerData = customerDataValue
    },
    removeToken() {
      this.token = null
    },
    removeUserData() {
      this.userData = null
    },
    removeExpireToken() {
      this.expireToken = null
    },
    removeCustomerData() {
      this.customerData = null
    },
    removeCustomers() {
      localStorage.removeItem('customers')
    }
  },
  getters: {
    getToken() {
      return this.token
    },
    getUserData() {
      return this.userData
    },
    getCustomerData() {
      return this.customerData
    },
    getExpireToken() {
      return this.expireToken
    }
  },
  persist: true
});